import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import WistiaVideo from './WistiaVideo'
import { isShouldAutoPlayVideo } from 'store/entities/localSettings/selectors'
import { setShouldAutoPlayVideo } from 'store/entities/localSettings/actions'

const mapStateToProps = createStructuredSelector({
  isAutoPlayVideo: isShouldAutoPlayVideo,
})

const mapDispatchToProps = dispatch => ({
  setShouldAutoPlayVideo: () => dispatch(setShouldAutoPlayVideo(false)),
})

export default connect(mapStateToProps, mapDispatchToProps)(WistiaVideo)
